export { default } from './CompanyImage';
